import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  Center,
  Box,
} from "@chakra-ui/react";

export const SettingsPage = () => {
  return (
    <Center h="calc(100vh - 80px)">
      <Box
        border="2px solid"
        margin={"auto"}
        borderColor="gray.200"
        // borderRadius="md"
        // rounded="20px"
        w="800px"
        rounded="md"
        overflow={"hidden"}
      >
        <Table  bg="white" variant="simple" textAlign={"center"}>
          <Thead >
            <Tr>
              <Th>Name</Th>
              <Th>Mobile Number</Th>
              <Th>Availability</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>inches</Td>
              <Td>millimetres (mm)</Td>
              <Td>25.4</Td>
            </Tr>
            <Tr>
              <Td>feet</Td>
              <Td>centimetres (cm)</Td>
              <Td>30.48</Td>
            </Tr>
            <Tr>
              <Td>yards</Td>
              <Td>metres (m)</Td>
              <Td>0.91444</Td>
            </Tr>
          </Tbody>
        </Table>
      </Box>
    </Center>
  );
};
